// extracted by mini-css-extract-plugin
module.exports = {"detailPage":"catalog-detail_detailPage__Q5Dwv"};